import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SendCommandDto } from 'src/app/model/qModel.model';
import { ApiService } from 'src/app/services/api.service';
declare var $: any
@Component({
  selector: 'app-update-virus',
  templateUrl: './update-virus.component.html',
})
export class UpdateVirusComponent implements OnInit {
  isLoading: boolean = false
  deviceId: string = '';
  lockData: boolean = false;
  mobileDevice: any[] = [];
  UPDATE_VIRUS_DB: string = 'UPDATE_VIRUS_DB'
  constructor(private _router: Router, private _Service: ApiService,
    private activatedRoute: ActivatedRoute, private _toastr: ToastrService, private location: Location) { }
  isLock: boolean = false;
  sendCommanddto: SendCommandDto = new SendCommandDto();
  restorePublishForm: FormGroup = new FormGroup({
    mobileDeviceName: new FormControl('')
  })
  ngOnInit(): void {
    this.deviceId = this.activatedRoute.snapshot.params["id"];
    this.getLock();
    this.getDevicesInUser();
  }
  goBack() {
    this.location.back()
  }


  openLockModal() {
    $("#LockPopup").modal("show");
    this.isLock = true
  }


  isLockClicked() {
    this.isLock = true
  }


  // Fetching the Lock date data here 
  getLock() {
    this._Service.getService(this._Service.API_URL.getLock + this.deviceId).subscribe((response) => {
      if (response && response.status.code === 200) {
        this.lockData = response.data;
      }

    })
  }

  // Send Command
  errorMessage: string = '';
  sendCommand() {
    this.isLoading = true;
    try {
      this.sendCommanddto.deviceId = this.deviceId;
      this.sendCommanddto.requestType = 'UPDATE_VIRUS_DB'
      this._Service.postService(this._Service.API_URL.sendCommand, this.sendCommanddto).subscribe((response) => {
        if (response && response.status.code === 200) {
          this.isLoading = false;
          $("#LockPopup").modal("show");
          this.getLock();
          this.isLock = true
          setTimeout("$('#LockPopup').modal('hide');", 1500);
          this._toastr.success('', response.status.message);
        } else {
          this._toastr.error('', response.status.message)
          this.isLoading = false;
        }
        this.isLoading = false;
      })
    } catch (error) {
      this.isLoading = false;
    }
  }

  //  Get All Device 
  // Fetching all mobile device added from Manage Device
  deviceName: any
  getDevicesInUser() {
    this.isLoading = true;
    try {
      this._Service.getService(this._Service.API_URL.getDevicesInUser).subscribe((response: any) => {
        if (response && response.status.code === 200) {
          this.isLoading = false;
          this.mobileDevice = response.data;
          if (this.deviceId) {
            this.mobileDevice.forEach((element: any) => {
              if (this.deviceId == element.id) {
                this.deviceName = element.name;
                this.restorePublishForm.controls['mobileDeviceName'].setValue(element.id);
              }
            });
          }
          else {
            let deviceId = response.data[0].id;
            this.restorePublishForm.controls['mobileDeviceName'].setValue(deviceId);
          }
        } else {
          this.isLoading = false;
        }
      })
    } catch (error) {
      this.isLoading = false;
    }
  }

  onMobileDeviceSelect(evt: any) {
    this.deviceId = evt.target.value;
    this.mobileDevice.forEach(element => {
      if (this.deviceId == element.id) {
        this.deviceName = element.name;
      }
    });
  }


  //  Closing Modal
  closeModal() {
    $("#LockPopup").modal("hide");
    this.isLock = false;
  }

}
